import { useState } from "react";
import { Button, Paper } from "@mui/material";
import { useForm } from "react-hook-form";
import FormContainer from "./rh_form_elements/rh-form-container";
import TextFieldElement from "./rh_form_elements/rh-text-field-element";
// import PhoneFieldElement from "./rh_form_elements/rh-phone-field-element";
// import EmailFieldElement from "./rh_form_elements/rh-email-field-element";
// import DatePickerElement from "./rh_form_elements/rh-date-picker-element";
import { Stack } from "@mui/material";



export default function CaseProfileForm(props) {


  const defaultValues = props.data?props.data:{};
  // Jurisdiction is captured in the case-details form (CaseInfoForm), not here —
  // case create no longer stamps a default jurisdictionState (ADR-003).


  const [values, setValues] = useState(defaultValues)


  const formContext = useForm({
    defaultValues: defaultValues, values
  });

  const { handleSubmit, reset, control, setValue, formState: { errors } } = formContext;


  return (



      <Paper
        style={{
          display: "grid",
          gridRowGap: "20px",
          padding: "20px",
          //margin: "10px 300px",
          maxWidth: "500px",
        }}
      >
        <FormContainer formContext={formContext} handleSubmit={handleSubmit} >
          <Stack spacing={2}>
            <TextFieldElement
              name="caseName"
              label="Case Name"
              required
              helperText="Name or Title of the Case, e.g. 'Smith v. Smith'"/>
            {/* jurisdictionState now lives in the case-details form (CaseInfoForm). */}
            {/* <TextFieldElement
              name="courtJurisdiction"
              label="Court and Jurisdiction"
              required
              helperText="Court with Jurisdiction e.g. 'Superior Court of Fulton County'"
              />
            <TextFieldElement
              name="caseNumber"
              label="Case Number"
              required
              helperText="Case Number as filed with the court"
              />
            <TextFieldElement
              name="petitionerName"
              label="Petitioner Name"
              required
              helperText="Name of the Petitioner (the person who filed the case)"
              />
            <TextFieldElement
              name="respondentName"
              label="Respondent Name"
              required
              helperText="Name of the Respondent (the person responding to the case)"
              />
            <DatePickerElement
              name="marriageDate"
              label="Date of Marriage"
              required
              helperText="Date of Marriage"
              control={control}
              rules={{
                validate: (value) => {
                  if (!value) return "Date of Marriage is required";
                  if (value > new Date()) return "Date of Marriage cannot be in the future";
                  return true;
                }
              }} /> */}
          </Stack>


          <Button
            style={{
              //padding: "20px",
              margin: "10px 0px",
              maxWidth: "75px",
            }}
            onClick={handleSubmit(props.onSubmit)} variant={"contained"}>
            Save
          </Button>
          <Button style={{
            //padding: "20px",
            margin: "10px 10px",
            maxWidth: "75px",
          }}
            onClick={props.onCancel} variant={"outlined"}>
            Cancel
          </Button>


        </FormContainer>

      </Paper>




  );
};